import { useMemo } from "react";
import { useSelector } from "react-redux";
import groupBy from "lodash/groupBy";
import isEmpty from "lodash/isEmpty";

import {
  getCartOrderLineItems,
  getCartOrderMedleySets,
  getCartOrderProductSets,
  getCartProductZoneList,
} from "@selectors/cart";

import { usePreviewModeContext } from "@contexts/preview-mode-context";

import CartListingWrapper from "@sharedComponents/cart/send-to-many/cart-listing-wrapper";

const emptyArr = [];
const emptyObj = {};

const CountryWiseCartListing = ({ variantDataloading, variantsMapping, variantData }) => {
  const lineItems = useSelector(getCartOrderLineItems);
  const productSets = useSelector(getCartOrderProductSets);
  const medleySets = useSelector(getCartOrderMedleySets);
  const cartProductZoneList = useSelector(getCartProductZoneList);

  const { isGuestOrPreviewMode } = usePreviewModeContext();

  const getGroupedProductByZoneId = () => {
    const lineItemsGrouping = groupBy(lineItems, "zoneId") || emptyObj;
    const productSetsGrouping = groupBy(productSets, "zoneId") || emptyObj;
    const medleySetsGrouping =
      groupBy(medleySets, ({ medleyComponents = [] }) => medleyComponents[0]?.zoneId) || emptyObj;
    const allGroupedData = cartProductZoneList.map((zoneId) => {
      const lineItemsData = lineItemsGrouping[zoneId] || emptyArr;
      const productSetsData = productSetsGrouping[zoneId] || emptyArr;
      const medleySetsData = medleySetsGrouping[zoneId] || emptyArr;
      return { lineItemsData, productSetsData, medleySetsData, zoneId: zoneId.toString() };
    });
    return allGroupedData || emptyArr;
  };

  const groupedProductByZoneId = useMemo(() => {
    if (
      variantDataloading ||
      (!isGuestOrPreviewMode && !variantData) ||
      (isEmpty(lineItems) && isEmpty(productSets) && isEmpty(medleySets))
    ) {
      return emptyArr;
    }
    return getGroupedProductByZoneId();
  }, [variantDataloading, variantData, lineItems, productSets, medleySets]);

  return (
    <>
      {groupedProductByZoneId.map((productList) => {
        return (
          <CartListingWrapper
            key={`zone-${productList.zoneId}`}
            productListData={productList}
            variantsMapping={variantsMapping}
            variantDataloading={variantDataloading}
          />
        );
      })}
    </>
  );
};

export default CountryWiseCartListing;
